export default __webpack_public_path__ + "static/media/anneler-gunu.e35e5cc7.mp4";